import { api } from "@/lib/api";

export async function startCheckout(lookup_key) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    origin_url: window.location.origin,
  });
  if (!data?.checkout_url) throw new Error("Mangler betalingslenke");
  window.location.href = data.checkout_url;
}

export async function claimFreePlan(lookup_key, email) {
  const { data } = await api.post("/checkout/free-claim", {
    lookup_key,
    email,
    origin_url: window.location.origin,
  });
  if (!data?.download_token) throw new Error("Mangler nedlastingslenke");
  return data.download_token;
}
